export default __webpack_public_path__ + "static/media/closeCross_rightbox.dc942aee.svg";